import { makeStyles } from '@material-ui/core';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';

const useStyles = makeStyles({
  tableContainer: {
    maxHeight: '50vh',
    overflow: 'auto',
    marginBottom: `${spacing.small}`,

    '& > table': {
      borderCollapse: 'collapse',
      width: '97%',
    },
    '& > table > thead, th': {
      position: 'sticky',
      top: 0,
      zIndex: 999,
      backgroundColor: colors.white,
    },
    '& > table > tbody': {
      borderTop: `1px solid ${colors.lightGray}`,
      borderBottom: `1px solid ${colors.lightGray}`,
    },
    '& > tr, th': {
      margin: 0,
      padding: 0,

      color: colors.black,
      fontSize: fonts.sizes.small,
      letterSpacing: '0.1',
      lineHeight: '24px',
      fontWeight: fonts.weights.medium,
    },
    '& > tr, td': {
      margin: 0,
      padding: '1px 1px',
      borderBottom: `1px solid ${colors.lightGray}`,

      wordBreak: 'break-all',
      color: colors.black,
      fontSize: fonts.sizes.small,
      letterSpacing: '0.25px',
      lineHeight: '20px',
      fontWeight: fonts.weights.normal,
    },
  },
  tooltipLabel: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: colors.white,
  },
  tooltipCenterContent: {
    textAlign: 'center',
    width: '100%',
  },
  highlightedRow: {
    backgroundColor: colors.lightGray,
    float: 'right',
    marginLeft: '10px',
  },
  resizableColumn: {
    '&:hover': {
      '& > div:last-child': {
        width: '6px',
        height: '100%',
        position: 'absolute',
        right: 6,
        top: 0,
        backgroundColor: colors.white,
        borderLeft: `1px solid ${colors.primary}`,
        borderRight: `1px solid ${colors.primary}`,
        transform: 'translateX(50%)',
        zIndex: 1,
        touchAction: 'none',
        cursor: 'col-resize',
      },
    },
  },
});

export default useStyles;
